type ErrorType = {
  message: string
  code: number
}

export const InvalidDateError: ErrorType = {
  message: 'Invalid date provided.',
  code: 1
}

export const InvalidCountInputError: ErrorType = {
  message: 'Invalid count provided. Expected an integer with a positive value.',
  code: 2
}

export const InvalidOffsetInputError: ErrorType = {
  message: 'Invalid offset provided. Expected an integer with a positive value.',
  code: 3
}
